import "./Gigs.css"

const Gigs = ({gigsRef}) => {

  return (
    <div ref={gigsRef} className="block" id="gigs">
      <h1>Gigs</h1>
      <p>Need a guitarist for your wedding? Need some soothing background noise at your holiday work party? 
        Contact me with any commissions or requests for your special event!</p>

      <b>Rate: $120 per hour</b>

    </div>
  )
}

export default Gigs
